/**
 * Resizing bar which handles resize of parent window
 */
import { useEffect, useRef, useState } from 'react';

import './styles.scss';

const BOUNDS = 40;

interface IResizerProps {
  targetClass: string;
  storageKey?: string;
  topGap?: number;
  bottomGap?: number;
  styleProperty: string;
}

/**
 * Resizer for tickers modal container
 * @param props
 * @returns
 */
const Resizer = ({
  targetClass,
  storageKey,
  topGap,
  bottomGap,
  styleProperty,
}: IResizerProps) => {
  const [resizing, setResizing] = useState<boolean>(false);
  const handleRef = useRef<any>(null);
  const element = document.getElementsByClassName(targetClass)[0];
  const maxAllowedHeight = bottomGap
    ? window.innerHeight - bottomGap
    : window.innerHeight;

  const onStart = (e: any) => {
    e.preventDefault();
    setResizing(true);
  };

  const onEnd = (event: any) => {
    event.preventDefault();
    setResizing(false);
    // Save result
    const rect = element.getBoundingClientRect();
    if  (storageKey) {
      localStorage.setItem(storageKey, String(rect.height));
    }
  };

  useEffect(() => {
    let onMove: any;
    if (resizing) {
      onMove = (event: any) => {
        const rect = element.getBoundingClientRect();
        const diff = event.clientY - rect.bottom;
        let target = element.clientHeight + diff;
        if (topGap && target < topGap) {
          target = topGap;
        }
        if (target + BOUNDS > maxAllowedHeight) {
          target = maxAllowedHeight - BOUNDS;
        }
        (element as any).style[styleProperty] = `${target}px`;
      };
      window.addEventListener('mouseup', onEnd);
      window.addEventListener('mousemove', onMove);
    }

    return () => {
      window.removeEventListener('mouseup', onEnd);
      window.removeEventListener('mousemove', onMove);
    };
  }, [resizing]);

  return <div className='resizer' ref={handleRef} onMouseDown={onStart} />;
};

export default Resizer;
